module.exports = __webpack_public_path__ + "static/P1-3e10ee387bbcc83a09a1eea9a14e6f70.pdf";